<template>
    <div class="mt15">
        <div class="order_main_btn text_center">
            <el-button type="primary" @click="submitForm()">저장</el-button>
            <el-button type="info" @click="$router.back()">목록</el-button>
            <div class="order_btn">
                <el-button  type="primary" @click="sendUpdateStatus(20)">입금완료 처리</el-button>
                <el-button  type="danger" @click="updateCancel()">주문취소</el-button>
            </div>
        </div>
        <order-list-reason-modal></order-list-reason-modal>
    </div>
</template>

<script>
import orderMixins from "@/mixins/orderMixins";
import OrderListReasonModal from "@/components/modal/OrderListReasonModal.vue";

export default {
    name: "BeforeDepositSaveLayout",
    mixins: [orderMixins],
    components: {OrderListReasonModal},
    inject: [],
    provide() {
        return {}
    },
    props: {
        runWrite: {
            default: () => {
            }, type: Function
        },
        orderKey: {default:0},
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        sendUpdateStatus(type){
            let params ={
                c_status: type,
                c_idx :this.orderKey
            }
            this.updateStatus(params)
        },
        updateCancel(){
            this.$modal.show('order-list-reason-modal',{type:'beforeCancel',key:this.orderKey})
            // 취소 모달
        },
        submitForm() {
            this.runWrite();
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
